import { FunctionComponent, useCallback, useMemo } from 'react'

import translate from '@i18n'
import useSportEntities from '@hooks/useSportEntities'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

import GroupedCompetitorsList from './GroupedCompetitorsList'
import Placeholder from './Placeholder'

type FollowMyTeamSportCompetitorsListProps = {
  currentSearchTerm: string
  currentFilterId: string
}

const FollowMyTeamSportCompetitorsList: FunctionComponent<
  FollowMyTeamSportCompetitorsListProps
> = ({ currentSearchTerm, currentFilterId }) => {
  const { error } = useSportEntities()

  const handleReload = useCallback(() => {
    window.location.reload()
  }, [])

  const sportCompetitorsListContent = useMemo(
    () =>
      error ? (
        <Placeholder
          iconName="user-robot-xmarks-solid"
          title={translate('network.error.title')}
          text={translate('network.error.text')}
        >
          {error && (
            <PrimaryCTAButton
              colorVariant="black"
              size="large"
              iconName="arrow-rotate-left"
              onClick={handleReload}
            >
              {translate('network.error.reload')}
            </PrimaryCTAButton>
          )}
        </Placeholder>
      ) : (
        <GroupedCompetitorsList
          currentSearchTerm={currentSearchTerm}
          currentFilterId={currentFilterId}
        />
      ),
    [currentFilterId, currentSearchTerm, error, handleReload],
  )

  return sportCompetitorsListContent
}

export default FollowMyTeamSportCompetitorsList
